import { Project } from '@Types/common';
import { MultiSelectOption } from '@Types/MultiSelectOption';
import { PROJECT_LOCATION_BULK_UPDATE_OPTIONS as BulkOptions } from '@Constants/constants';

export const bulkOptions = [
    { id: BulkOptions.AddBaseline.value, name: BulkOptions.AddBaseline.label },
    { id: BulkOptions.RemoveBaseline.value, name: BulkOptions.RemoveBaseline.label },
    { id: BulkOptions.Publish.value, name: BulkOptions.Publish.label },
    { id: BulkOptions.RemoveScope.value, name: BulkOptions.RemoveScope.label },
    { id: BulkOptions.ChangeManager.value, name: BulkOptions.ChangeManager.label, icon: BulkOptions.ChangeManager.icon },
    { id: BulkOptions.ChangeZeroDate.value, name: BulkOptions.ChangeZeroDate.label, icon: BulkOptions.ChangeZeroDate.icon },
    { id: BulkOptions.Unpublish.value, name: BulkOptions.Unpublish.label, icon: BulkOptions.Unpublish.icon },
    { id: BulkOptions.OnHold.value, name: BulkOptions.OnHold.label, icon: BulkOptions.OnHold.icon },
    { id: BulkOptions.OffHold.value, name: BulkOptions.OffHold.label, icon: BulkOptions.OffHold.icon },
];

export interface LocationsProps {
    projectData: Project;
    subscriptionId: number;
    userColumns: Array<string>;
    onColumnsChange: (newColumns: Array<string>, saveMongo: boolean) => Promise<void>;
}

export interface ProjectLocationColumn {
    field: string;
    header: string;
    optionLabel?: string;
    isFeatureEnabled: boolean;
    default: boolean;
    isSortable: boolean;
    filterElement?: React.JSX.Element;
    body?(rowData: any): React.JSX.Element | React.JSX.Element[] | string | null;
    style?: React.CSSProperties;
    width?: string;
    textAlign?: string;
    reorderable?: boolean;
}

export interface SearchParams {
    projectKey: string;
    baselineIds: Array<number>;
    isActive: boolean | null;
    pageSize: number;
    pageNumber: number;
    sortBy: string;
    sortDir: string;
    isOnHold: boolean | null;
    multiColumnSort: Array<{ [key: string]: string }>;
    isPushedDown: boolean | null;
    locationAbbreviations: Array<string>;
    projectManagerIds: Array<number>;
    zeroDates: Array<string>;
    projectZeroDates: Array<MultiSelectOption>;
    locationName: string;
}
export type FilterValue = boolean | undefined | string | number;

export interface ProjectLocationFilters {
    projectZeroDates: Array<MultiSelectOption>;
    baselines: Array<MultiSelectOption>;
    selectedBaselines: Array<MultiSelectOption>;
    projectManagers: Array<MultiSelectOption>;
    selectedProjectManagers: Array<MultiSelectOption>;
    isOnHold: boolean | undefined;
    isActive: boolean | undefined;
    brands: Array<MultiSelectOption>;
    continents: Array<MultiSelectOption>;
    managementCompanies: Array<MultiSelectOption>;
    areas: Array<MultiSelectOption>;
    regions: Array<MultiSelectOption>;
    types: Array<MultiSelectOption>;
    countries: Array<MultiSelectOption>;
    generation: string;
    locationAbbreviations: string;
    locationName: string;
    selectedStatus: number;
}
